module.exports = __webpack_public_path__ + "assets/img/number_times_ok.234ef7d8.png";